<template>
  <keep-alive>
    <div class="multi-team-select" :class="{ opened: opened }" v-if="show" v-click-outside="collapse">
      <notification-circle v-if="activeTeam"></notification-circle>
      <h2 class="active-team" @click="open" v-if="activeTeam">
        {{ $store.getters["teamList/activeTeam"].teamName }}
      </h2>
      <h6 v-if="!activeTeam" :key="statusKey" :class="{ 'error msg-error': hasErrors }">
        {{ statusText }}
      </h6>
      <div class="options">
        <div class="options-wrapper">
          <div class="options-list" v-if="teams">
            <a v-for="(team, key) in teams" :key="key" :class="{ selected: team.id === activeTeam.id }"
              @click="select(team.id)" class="option">
              <v-badge overlap :color="colors['orange']" :value="Object.keys(team.joinRequests).length ?? 0"
                :content="Object.keys(team.joinRequests).length ?? 0" offset-x="24" offset-y="24">
                <img :src="resolveImgUrl(team)" @error="fallbackImgUrl($event)" :alt="team.teamName" />
              </v-badge>
              <span class="age">{{ team.teamAge }}</span>
              <h3 class="name">{{ team.teamName }}</h3>
            </a>
          </div>
        </div>
      </div>
    </div>
  </keep-alive>
</template>

<script>
import { mapState } from "vuex"
import constants from "@/constants.js"
import colors from "@/assets/sass/_variables.sass"
import NotificationCircle from "./NotificationCircle"

export default {
  name: "MultiTeamSelect",
  components: { NotificationCircle },
  data() {
    return {
      colors,
      opened: false,
      statusText: "Loading...",
      hasErrors: false,
      statusKey: false,
    }
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, _state) => {
      if (mutation.type === "teamList/addError") {
        this.statusText = "Error Loading Teams"
        this.statusKey = !this.statusKey
        this.hasErrors = true
      }
    })
    if (this.statusTextE) {
      this.statusKey = !this.statusKey
      this.hasErrors = true
      this.statusText = this.statusTextE
    }
  },
  beforeDestroy() {
    this.unsubscribe()
    clearTimeout(this.timeout)
  },
  watch: {
    noTeams: {
      handler: function (newValue) {
        if (newValue) {
          this.statusText = "No Team Selected / Created"
          this.statusKey = !this.statusKey
          this.hasErrors = false
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState("teamList", {
      statusTextE: function (state) {
        if (state.errors.size) {
          this.hasErrors = true
          this.statusKey = !this.statusKey
          return "Error Loading Teams"
        }
      },
      noTeams: (state) => state.noTeams,
    }),
    activeTeam() {
      return this.$store?.getters?.["teamList/activeTeam"] ?? false
    },
    selectedTeam() {
      return this.$store.getters["teamList/activeTeam"]
    },
    loading() {
      return !this.$store.getters.initialized
    },
    show() {
      return true
    },

    teams() {
      return this.$store.state.teamList.teams
    },
  },

  methods: {
    fallbackImgUrl(event) {
      event.target.src = constants.icons.team
    },
    resolveImgUrl(team) {
      const pattern = /teamImg|defaultProfileImg/gi
      if (team.imgUrl && !pattern.test(team.imgUrl)) {
        return String(team.imgUrl)
      }
        return String(constants.icons.team)
    },

    open() {
      this.opened = !this.opened
    },
    collapse() {
      this.opened = false
    },
    async select(teamId) {
      this.$store.commit("setOverlay", true)
      this.opened = false
      await this.$store.dispatch("teamList/selectTeam", teamId)
      this.$store.commit("setOverlay", false)
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../../assets/sass/variables'
.multi-team-select
  width: 100%
  display: flex
  flex-direction: row

.active-team
  font-size: 20px
  font-weight: 600
  overflow-x: hidden
  overflow-y: visible
  text-indent: 5px
  position: relative
  text-overflow: ellipsis
  white-space: nowrap

  &:before
    border-right: 2px solid $white
    border-top: 2px solid $white
    content: ''
    display: inline-block
    margin-right: 10px
    height: 15px
    position: relative
    transform: rotate(135deg)
    transition: all .5s ease
    width: 15px
    cursor: pointer


.options
  background: $bg-gray-gradient
  font-size: 18px
  left: 0
  overflow: hidden
  padding: 10px
  opacity: 1
  position: absolute
  top: 50px
  transition: transform .5s ease
  transform: translateY(calc(-100%))
  // transform-origin: top
  width: 100%
  z-index: -1
  // height: 0
  overflow: hidden
  display: block


  .options-wrapper
    display: block
    overflow-x: scroll

  .options-list
    display: grid
    grid-auto-flow: column
    column-gap: 10px
    // align-items: stretch
    // flex-wrap: nowrap
    // align-items: center
    // TODO account for a lot of teams
    // ! when there are a lot of teams, the most left ones aren't visible

  img
    border: 5px solid $purple
    border-radius: 100%
    transition: all .5s ease
    // height & width are hard set to 100px by .options
    height: 100px
    width: 100px

  .option
    color: $white
    cursor: pointer
    display: inline-block
    // margin: 0 10px
    margin: 0 auto
    min-width: 100px
    position: relative
    text-align: center
    width: 100px

    &.selected img, &:hover img
      border-color: $brightest-green

  .age
    display: block
    font-size: 0.7em
    line-height: 1

  .name
    font-size: 1em
    word-break: break-word

.opened
  .active-team:before
    transform: rotate(-45deg)

  .options
    // animation: .3s ease both fade-in
    transition: transform .3s ease-in-out
    transform-origin: top
    transform: translateY(0)
    // top: 50px
    height: auto
    opacity: 1
    .options-wrapper
      width: 100%

  .options:target
    transform: scaleY(0)
    height: 0
.msg-error, .info-toaster
  color: white
  padding: 10px
  border-radius: 10px
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12)
// @keyframes fade-in
//   0%
//     // opacity: 0
//     transform: scale(0)
//   100%
//     // opacity: 1
//     transform: scale(1)
</style>
